import React from "react";
import { colors } from "../../../../themes/Colors";
import { BaseButtons, TextInputField } from "../../../common-components";

const ForgotPasswordPopUp = ({ display, onCloseClick, width }) => {
  return (
    <div
      style={{
        width: display ? "100%" : 0,
        height: display ? "100%" : 0,
        position: "absolute",
        overflow: "hidden",
        backgroundColor: colors.primaryBlue50,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 0,
        // transition: "all 0.4s",
      }}
    >
      <div
        style={{
          height: display ? (width > 599 ? 540 : "95%") : 0,
          width: display ? (width > 599 ? 500 : "90%") : 0,
          backgroundColor: colors.white,
          borderRadius: 20,
          borderStyle: "solid",
          borderWidth: 3,
          borderColor: colors.white,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          transition: "all 0.4s",
          zIndex: 1,
          marginTop: width > 599 ? 40 : 0,
        }}
      >
        <div style={{ marginTop: 20, marginBottom: 10 }}>
          <div
            style={{
              color: colors.primaryBlue,
              fontSize: 32,
              fontWeight: "bold",
              width: "100%",
              textAlign: "center",
            }}
          >
            FORGOT YOUR PASSWORD ?
          </div>
        </div>
        <div
          style={{
            flex: 1,
            widht: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <TextInputField
            labelTitle={"Email"}
            mini={true}
            width={"100%"}
            size={"70%"}
          />
          <div
            style={{
              width: width > 599 ? "75%" : "80%",
              marginTop: 10,
              fontSize: 12,
            }}
          >
            Type the email of the account user that has forgot thier password,
            we will send you a verifaction code to your email to allow for
            password change...
          </div>
        </div>
        <BaseButtons
          onClick={onCloseClick}
          label={"VALIDATE CODE"}
          borderRadius={8}
          width={280}
          backgroundColor={colors.secondaryDarkBlue}
        />
        <div style={{ height: 10 }} />
        <BaseButtons
          onClick={onCloseClick}
          label={"REQUEST CODE"}
          borderRadius={8}
          width={280}
          backgroundColor={colors.secondaryDarkBlue}
        />
        <div style={{ height: 10 }} />
        <BaseButtons
          onClick={onCloseClick}
          label={"CLOSE"}
          borderRadius={8}
          width={280}
          backgroundColor={colors.secondaryDarkBlue}
        />
        <div style={{ height: 20 }} />
      </div>
    </div>
  );
};

export default ForgotPasswordPopUp;
